theme.layerBanner = {};
theme.LayerBannerSection = (function() {
  function runSliderBanner(wrap) {
    wrap.find('.zoom-fade.lazyloaded').addClass('ignore-effect');
    BT.initSlider(wrap, true);
  }

  function LayerBannerSection(container) {
    this.wrap = $(container);
    if(!Shopify.designMode) {
      var timeout = BT.data.cacheWindowWidth < BT.options.windowScreen.desktop ? 2300 : 1800;
      setTimeout(function(){
        runSliderBanner(this.wrap);
      }.bind(this), timeout);
    } else {
      runSliderBanner(this.wrap);
    }
    BT.applyCustomColorSwatches(this.wrap);
    BT.initDealCountdown(this.wrap);
    
    this.slider = this.wrap.find(BT.getSliderSelector());
  }

  return LayerBannerSection;
})();

theme.sections.constructors['layer-banner'] = theme.LayerBannerSection;